<template>
    <div class="section">
        <Login />
      <!-- <pre>{{emailQueue}}</pre> -->
      
        <div v-if="$getUser() && !$getUser().isAnonymous && $getUser().email == 'alissa.w.bell@gmail.com'" class="container ">
            <h1 class="title is-2">Approval Email Queue</h1>
            <div style="font-size:22px">{{Object.keys(emailQueue).length + ' emails to send'}}</div>
            <div >
                <div v-for="address in Object.keys(emailQueue)" :key="address">
                    <div class="container card" style="padding:20px; text-align:left; margin-top:20px !important; font-size:16px">
                        <p>{{address}}</p><br>
                        <p style="font-size:13px">
                            <span style="font-size:13px">Hello, and thanks for submitting your {{emailQueue[address].urls.length > 1 ? 'blog posts' : 'blog post'}} to BikeSleepBike.</span><br><br>
                            <span style="font-size:13px">{{emailQueue[address].urls.length > 1 ? 'These posts have' : 'This post has'}} been approved and added:</span>
                            <ul style="list-style:disc; list-style-position:inside">
                            <li v-for="url in emailQueue[address].urls" :key="url" style="font-size:13px">
                                <a :href="url">{{url}}</a><br>
                            </li>
                            </ul><br>
                            <span style="font-size:13px">This means other cyclists can discover {{emailQueue[address].urls.length > 1 ? 'them' : 'it'}} on <a href='https://bikesleepbike.com'>bikesleepbike.com</a>. Thanks for contributing to this project and helping other riders!
                            </span><br><br>
                            <span style="font-size:13px">To see a list of all your linked posts, visit this personalized page:</span><br>
                            <a  style="font-size:13px" :href="'https://bikesleepbike.com/sites/' + emailQueue[address].site">{{'https://bikesleepbike.com/sites/' + emailQueue[address].site}}</a><br><br>
                            <span style="font-size:13px">To change the information associated with a post, you can return to the <a href="https://bikesleepbike.com/share">Share Page</a> and enter the same post URL.</span><br>
                        </p>
                    <div class="admin-buttons" style="text-align:right; margin-top:30px">
                        <b-button  type="is-danger" @click="markSent(emailQueue[address])">Mark Sent</b-button>
                    </div>
                    </div>
                    
                </div>
               
            </div>
        </div>
     
    </div>  
</template>

<script>
// import {allcountries} from "../data.js";
// import AdminApproveNewPage from '@/components/AdminApproveNewPage';
import Login from '@/components/Login';

export default {
    name: 'AdminEmails',
    components: {Login},
   
    data () {
        return {
         
            emailQueue:{},
            
        }
    
    },
    computed: {
       
    },
    methods: {
     
        loadEmails() {
            var that = this;
            that.$db.collection("emails").where("sent", "==", false).onSnapshot((querySnapshot) => {
                that.emailQueue = {};
                querySnapshot.forEach(function(doc) {
                    var address = doc.data().address;
                    if (address in that.emailQueue) {
                        that.emailQueue[address].urls.push(doc.data().post_url);
                        that.emailQueue[address].ids.push(doc.id);
                    } else {
                        that.emailQueue[address] = {address: address, site: doc.data().site_url, urls:[doc.data().post_url], ids:[doc.id]};
                    }
                    // const idObj = {id: doc.id};
                    // that.emailQueue.push({...idObj, ...doc.data()});
                });
            });



            // .get()
            //     .then(function(querySnapshot) {
            //         that.emailQueue = {};
            //         querySnapshot.forEach(function(doc) {
            //             var address = doc.data().address;
            //             if (address in that.emailQueue) {
            //                 that.emailQueue[address].urls.push(doc.data().post_url);
            //             } else {
            //                 that.emailQueue[address] = {address: address, site: doc.data().site_url, urls:[doc.data().post_url]};
            //             }
            //             // const idObj = {id: doc.id};
            //             // that.emailQueue.push({...idObj, ...doc.data()});
            //         });
            //         console.log("Loading email queue");
            //         console.log(that.emailQueue);
            //     })
            //     .catch(function(error) {
            //         console.log("Error loading email queue: ", error);
            //     });



          
        },
        markSent(emailObj) {
            var that = this;
            // console.log(emailObj);
            var ids = emailObj.ids;
            for (var idx in ids) {
                // console.log(that.$keyify(ids[idx]));
                that.$db.collection("emails").doc(ids[idx]).set( {sent: true, sent_on: new Date()}, {merge: true})
                .then(function() {
                    console.log("Marking sent email for " + ids[idx]);
                }).catch(function(error) {
                    console.log("Error marking sent email for " + ids[idx] + ": " + error);
                });
            }
            // that.$db.collection("emails").doc("sent", "==", false).onSnapshot((querySnapshot) => {
        }
        
    },
    mounted() {
        this.loadEmails();

      
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   
   

  
</style>


<!-- 
TODO
- disallow dup urls - if already exists, offer option to edit instead (change merge to false)
- strip after ?
- extract human readable key from url
- validate url
- tags for solo etc, surface, language
- let people add new tags for route
- states for US


 -->



// WEBPACK FOOTER //
// src/components/AdminEmails.vue